import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'

export const fetchSuggestedGroupsQuery = gql`
  query suggestedGroups($limit: Int!) {
    suggestedGroups(limit: $limit) {
      totalDocs
      docs {
        id
        name
        totalMembers
        visibility
        profileImage {
          id
          sizes {
            small {
              url
            }
            medium {
              url
            }
          }
        }
        university {
          slug
        }
        universityCourse {
          slug
        }
        allowedUserTypes
      }
    }
  }
`

export interface SuggestedGroupsQueryInput {
  limit: number
}

export interface SuggestedGroupsQueryOutput {
  suggestedGroups: {
    totalDocs: number
    docs: {
      id: string
      name: string
      description: string
      visibility: string
      totalMembers: number
      profileImage: {
        sizes: {
          small: {
            url: string
          }
          medium: {
            url: string
          }
        }
      }
      university?: {
        slug: string
      }
      universityCourse?: {
        slug: string
      }
      allowedUserTypes: string[]
    }[]
  }
}

export const useSuggestedGroupsQuery = (
  input: SuggestedGroupsQueryInput,
  options?: QueryHookOptions<SuggestedGroupsQueryOutput, SuggestedGroupsQueryInput>
) =>
  usePersistedCacheQuery<SuggestedGroupsQueryOutput, SuggestedGroupsQueryInput>(fetchSuggestedGroupsQuery, {
    variables: input,
    ...options,
  })
